module.exports = {
  LABEL_IMAGE: 'LabelImage',
  LABEL_IMAGE_EDITABLE: 'LabelImageEditable',
};
